// 17 hub/tool/category links surfaced on the homepage and /resources so no page is orphaned.
export const GUIDES_AND_TOOLS = [
  { to: "/how-it-works", label: "How the program works" },
  { to: "/high-ticket-closing-playbook", label: "The high-ticket closing playbook" },
  { to: "/incentive-revenue-dashboard", label: "The incentive revenue dashboard" },
  { to: "/train-sales-team-to-present-travel-vouchers", label: "Train your team to present travel vouchers" },
  { to: "/partners/marketing-agencies", label: "Incentives for marketing agencies" },
  { to: "/vacation-certificates", label: "Vacation Certificates That Close High-Ticket Sales" },
  { to: "/travel-certificates", label: "Travel Certificates Your Sales Team Can Offer Instead of a Discount" },
  { to: "/vacation-incentives", label: "Vacation Incentives: A Closing Tool That Protects Margin" },
  { to: "/travel-incentive-programs", label: "Travel Incentive Programs for Customers, Not Just Employees" },
  { to: "/sales-incentive-programs", label: "Sales Incentive Programs That Close Deals Without Discounting" },
];

// Programs dropdown (nav) + footer column.
export const PROGRAM_LINKS = [
  { to: "/programs", label: "Vacation Certificate Programs" },
  { to: "/vacation-certificates", label: "Vacation Certificates" },
  { to: "/travel-certificates", label: "Travel Certificates" },
  { to: "/vacation-incentives", label: "Vacation Incentives" },
  { to: "/travel-incentive-programs", label: "Travel Incentive Programs" },
  { to: "/sales-incentive-programs", label: "Sales Incentive Programs" },
];
